module.exports = __webpack_public_path__ + "static/media/slide1.230751c4.jpg";